import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { DatatableWrapper, TableBody, TableHeader } from "react-bs-datatable";
import {
  FButton,
  FCard,
  FInputText,
  FItem,
  FTable,
  FTypo,
  FDialog,
} from "ferrum-design-system";
import IconNetworkCFrmStr from "../../../assets/img/icon-network-cfrm.svg";
import IconNetworkCFrmxStr from "../../../assets/img/icon-network-cfrmx.svg";
import IconNetworkBNB from "../../../assets/img/icon-network-bnb.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  getAPRValueAgainstFarm,
  getCrucibleDetail,
  getLatestStepToRender,
} from "./Helper";
import { ClipLoader } from "react-spinners";
import { RootState } from "../../../redux/rootReducer";
import { useWalletConnector, WalletConnector } from "foundry";
import { ConnectWalletDialogMultiSwap } from "../../../utils/connect-wallet/ConnectWalletDialogMultiSwap";
import { TruncateWithoutRounding } from "../../../utils/global.utils";
import { MultipleAPR } from "./multipleAPR";
import IconActiveRight from "../../../assets/img/apr-right-yellow.svg";
import IconActiveLeft from "../../../assets/img/apr-left-yellow.svg";
import { networksMap } from "../../../utils/const.utils";
import { networkLogoMap } from "../../../utils/constants";
import { createGlobalStyle, ThemeProvider } from "styled-components";
import { Crucible_Farm_Address_Details } from "./utils";
import { CrucibleClient } from "../../../container-components/web3Client/crucibleClient";
import { Web3Helper } from "../../../container-components/web3Client/web3Helper";
import { Table } from "react-bootstrap";

export const CardAPR = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [showConnectDialog, setShowConnectDialog] = useState(false);
  const { tokenV2 } = useSelector(
    (state: RootState) => state.walletAuthenticator
  );
  const { theme, content } = useSelector((state: RootState) => state.config);

  const {
    currentStep,
    currentStepIndex,
    stepFlowStepHistory,
    aprInformation,
    selectedCrucible,
    userCrucibleDetails,
    userLpStakingDetails,
  } = useSelector((state: RootState) => state.crucible);
  const [activeAPRIndex, setActiveAPRIndex] = useState(0);
  const [isRedirecting, setIsRedirecting] = useState(true);
  const [totalBalance, setTotalBalance] = useState({});

  const { isConnected, web3Sdk, walletAddress } = useWalletConnector();
  // console.log(selectedCrucible, userLpStakingDetails)
  const aprHeaderLabels = [
    "Daily Apr",
    "Weekly Apr",
    "Monthly Apr",
    "Lifetime Apr",
  ];

  useEffect(() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  }, []);

  useEffect(() => {
    if (!theme.crucibleConfig?.isDashboardEnabled) {
      const firstStep = (theme?.crucibleConfig?.crucibleFarms || [])[0];
      getStepToRender(
        firstStep?.stepFlowId,
        firstStep?.stepFlowName,
        firstStep?.contract,
        firstStep?.network,
        firstStep?.LpCurrency,
        firstStep?.LPstakingAddress,
        firstStep?.internalName
      );
      return;
    }

    setIsRedirecting(false);
  }, [theme.crucibleConfig]);

  useEffect(() => {
    Promise.all(
      theme?.crucibleConfig?.crucibleFarms?.map(async (stepFlow: any) => {
        const web3Helper = new Web3Helper(web3Sdk as any);
        const client = new CrucibleClient(web3Helper);
        const crucibleData = await client.getCrucibleDetails(
          dispatch,
          Crucible_Farm_Address_Details[stepFlow.internalName!].network,
          Crucible_Farm_Address_Details[stepFlow.internalName!].contract,
          walletAddress as string
        );
        if (crucibleData?.data) {
          //@ts-ignore
          setTotalBalance((value) => ({
            ...value,
            ...{ [stepFlow.internalName]: crucibleData?.data },
          }));
        }
        return crucibleData;
      })
    );
  }, [walletAddress]);

  const tableHeads: any[] = [
    {
      width: 200,
      prop: "sustainableCrucibleFarms",
      title: "Sustainable Crucible Farms",
    },
    { width: 200, prop: "totalStaked", title: "Total Staked" },
    { prop: "yourDeposit", title: "Your Deposit" },
    { prop: "yourRewards", title: "Your Rewards" },
    { prop: "action", title: <></> },
  ];

  const getTotalStaked = (farm: any) => {
    const value = Number(
      // @ts-ignore
      totalBalance[farm!]?.staking[0]?.totalStake || "0"
    ).toFixed(3);
    const selValue = Number(
      selectedCrucible[farm!]?.staking[0]?.totalStake || value || "0"
    ).toFixed(3);
    return Number(
      TruncateWithoutRounding(selValue || value || "0", 3)
    ).toLocaleString("en-US");
  };

  const getYourDeposited = (farm: any, lpAddress: any) => {
    let userStake = (userCrucibleDetails[farm!]?.stakes || []).find(
      (e: any) =>
        e.address.toLowerCase() === lpAddress.toLowerCase() ||
        (userCrucibleDetails[farm!] || {})?.currency.includes(
          lpAddress.toLowerCase()
        )
    );

    return farm?.includes("BNB")
      ? Number(
          TruncateWithoutRounding(userLpStakingDetails[farm!]?.stakes || "0", 3)
        )
      : Number(TruncateWithoutRounding(userStake?.stakeOf || "0", 3));
  };

  const getYourRewards = (farm: any, lpAddress: any) => {
    let userStake = (userCrucibleDetails[farm!]?.stakes || []).find(
      (e: any) =>
        e.address.toLowerCase() === lpAddress.toLowerCase() ||
        (userCrucibleDetails[farm!] || {})?.currency.includes(
          lpAddress.toLowerCase()
        )
    );

    if (farm?.includes("BNB")) {
      return TruncateWithoutRounding(
        web3Sdk?.utils.fromWei(
          String(userLpStakingDetails[farm!]?.rewards[0]?.rewardAmount || 0),
          "ether"
        ),
        3
      );
    } else {
      return TruncateWithoutRounding(userStake?.rewardOf || 0, 6);
    }
  };

  const getRewardSymbol = (farm: any) => {
    return selectedCrucible[farm!]?.symbol;
  };

  const getDepositedSymbol = (farm: any) => {
    return farm?.includes("BNB")
      ? `CAKE-LP ${selectedCrucible[farm!]?.symbol}-BNB`
      : selectedCrucible[farm!]?.symbol;
  };

  const data = theme?.crucibleConfig?.crucibleFarms?.map((stepFlow: any) => {
    return {
      sustainableCrucibleFarms: stepFlow.sustainableCrucibleFarms,
      stepFlowName: stepFlow.stepFlowName,
      totalStaked: getTotalStaked(stepFlow.internalName),
      yourDeposit: getYourDeposited(stepFlow.internalName, stepFlow.contract),
      yourRewards: getYourRewards(stepFlow.internalName, stepFlow.contract),
      apr:
        Object.keys(aprInformation).length &&
        getAPRValueAgainstFarm(aprInformation, stepFlow.internalName, "TBD"),
      logo: (
        <FItem display={"flex"} alignY={"center"} className="w-100">
          <span className="card-apr-images icon-network f-pr--5 flex">
            <img
              src={networkLogoMap[stepFlow.network]}
              height="24px"
              width="24px"
              style={{ marginRight: "3px" }}
              alt=""
            />
            <img src={stepFlow.logo} height="22px" width="22px" />
          </span>
        </FItem>
      ),
      id: stepFlow.stepFlowId,
      contract: stepFlow.contract,
      LpCurrency: stepFlow.LpCurrency,
      LPstakingAddress: stepFlow.LPstakingAddress,
      network: stepFlow.network,
      internalName: stepFlow.internalName,
    };
  });

  const body = data.map((stepFlow: any, index: number) => {
    return {
      key: index,
      sustainableCrucibleFarms: (
        <FItem
          data-label="Sustainable Crucible Farms"
          className={"col-crucible-farming"}
          display={"flex"}
          alignY="center"
        >
          <span className="network-icon-wrap f-mr-1">{stepFlow?.logo}</span>
          <FTypo color={theme?.colors?.primaryLight}>
            {stepFlow?.sustainableCrucibleFarms}
          </FTypo>
        </FItem>
      ),
      totalStaked: (
        <FTypo
          color={theme?.colors?.primaryLight}
          className={"col-amount start"}
        >
          {stepFlow?.totalStaked}
        </FTypo>
      ),
      yourDeposit: (
        <FTypo color={theme?.colors?.primaryLight} className={"col-amount"}>
          {stepFlow.yourDeposit}
        </FTypo>
      ),
      yourRewards: (
        <FTypo color={theme?.colors?.primaryLight} className={"col-amount"}>
          {stepFlow?.yourRewards || "0"}
        </FTypo>
      ),
      apr: (
        // <MultipleAPR apr={stepFlow.apr} />
        <FTypo
          color={theme?.colors?.primary}
          className="medium-text-700 text-center default-text-color"
        >
          {stepFlow?.apr[activeAPRIndex]?.value}
        </FTypo>
      ),
      action: (
        <div className="col-action">
          {isConnected && tokenV2 ? (
            <>
              <FButton
                //disabled={network != stepFlow.network}
                title={"Manage"}
                style={{ width: 124, height: 44 }}
                className={"clr_new_black"}
                onClick={() =>
                  getStepToRender(
                    stepFlow?.id,
                    stepFlow?.stepFlowName,
                    stepFlow?.contract,
                    stepFlow?.network,
                    stepFlow?.LpCurrency,
                    stepFlow?.LPstakingAddress,
                    stepFlow?.internalName
                  )
                }
              />
              <FButton
                //disabled={network != stepFlow.network}
                title={"Deposit"}
                style={{ width: 124, height: 44 }}
                className={"clr_new_black"}
                onClick={() =>
                  getStepToRender(
                    stepFlow?.id,
                    stepFlow?.stepFlowName,
                    stepFlow?.contract,
                    stepFlow?.network,
                    stepFlow?.LpCurrency,
                    stepFlow?.LPstakingAddress,
                    stepFlow?.internalName
                  )
                }
              ></FButton>
            </>
          ) : (
            <WalletConnector
              WalletConnectView={FButton}
              WalletConnectModal={ConnectWalletDialogMultiSwap}
              WalletConnectViewProps={{ className: "w-100" }}
            />
          )}
        </div>
      ),
    };
  });

  // {
  //   sustainableCrucibleFarms: "cFRM / BNB",
  //   internalName: "cFRM-BNB",
  //   stepFlowName: "cFRM / BNB Crucible Farm - Farming Dashboard Flow",
  //   totalStaked: getTotalStaked("cFRM-BNB"),
  //   yourDeposit: `${getYourDeposited("cFRM-BNB", "0x35E15ff9eBB37D8C7A413fD85BaD515396DC8008")}`,
  //   yourRewards: `${getYourRewards("cFRM-BNB", "0x35E15ff9eBB37D8C7A413fD85BaD515396DC8008")}`,
  //   logo: (
  //     <>
  //       <img src={IconNetworkCFrmStr} height="22px" width="22px" />
  //       <img src={IconNetworkBNB} height="22px" width="22px" />{" "}
  //     </>
  //   ),
  //   apr: Object.keys(aprInformation).length && getAPRValueAgainstFarm(aprInformation, 'cFRM-BNB'),
  //   network: "BSC",
  //   id: "6238314dd292da2db05524dd",
  //   contract: "0xaf329a957653675613D0D98f49fc93326AeB36Fc", // crucible contract address
  //   LpCurrency: "0x9aa0AB73409311984ED84f3Edef962201Bd11712", // CAKE-LP token for crucible and bnb pair
  //   LPstakingAddress: "0x35E15ff9eBB37D8C7A413fD85BaD515396DC8008", // lp farm where lp currency will be staked
  // },
  // {
  //   sustainableCrucibleFarms: "cFRM",
  //   stepFlowName: "cTestFrm Crucible Farm - Farming Dashboard Flow",
  //   totalStaked: getTotalStaked("cTestFrm"),
  //   yourDeposit: getYourDeposited(
  //     "cTestFrm",
  //     "0xB4927895cbEE88E651e0582893051b3B0f8D7DB8"
  //   ),
  //   yourRewards: getYourRewards(
  //     "cTestFrm",
  //     "0xB4927895cbEE88E651e0582893051b3B0f8D7DB8"
  //   ),
  //   apr:
  //     Object.keys(aprInformation).length &&
  //     getAPRValueAgainstFarm(aprInformation, "cFRM", "TBD"),
  //   logo: (
  //     <FItem display={"flex"} alignY={"center"} className="w-100">
  //       <span className="card-apr-images icon-network f-pr--5 flex">
  //         <img
  //           src={networkLogoMap["ARBITRUM"]}
  //           height="24px"
  //           width="24px"
  //           style={{ marginRight: "3px" }}
  //           alt=""
  //         />
  //         <img src={IconNetworkCFrmStr} height="22px" width="22px" />
  //       </span>
  //     </FItem>
  //   ),
  //   id: "63f8d6b55341c32c5281d6c2",
  //   contract: "0xe685d3CC0be48BD59082eDe30C3b64CbFc0326e2",
  //   LpCurrency: "0xb76b11410A506495418D20c58F9452c17CF285c1",
  //   LPstakingAddress: "0xB4927895cbEE88E651e0582893051b3B0f8D7DB8",
  //   network: "ARBITRUM",
  //   internalName: "cTestFrm",
  // },
  // {
  //   sustainableCrucibleFarms: "cFRM",
  //   stepFlowName: "cFRM Crucible Farm - Farming Dashboard Flow",
  //   totalStaked: getTotalStaked("cFRM"),
  //   yourDeposit: `${getYourDeposited(
  //     "cFRM",
  //     "0x35E15ff9eBB37D8C7A413fD85BaD515396DC8008"
  //   )}`,
  //   yourRewards: `${getYourRewards(
  //     "cFRM",
  //     "0x35E15ff9eBB37D8C7A413fD85BaD515396DC8008"
  //   )}`,
  //   apr:
  //     Object.keys(aprInformation).length &&
  //     getAPRValueAgainstFarm(aprInformation, "cFRM"),
  //   logo: (
  //     <FItem display={"flex"} alignY={"center"} className="w-100">
  //       <span className="card-apr-images icon-network f-pr--5 flex">
  //         <img
  //           src={networkLogoMap["BSC"]}
  //           height="24px"
  //           width="24px"
  //           style={{ marginRight: "3px" }}
  //           alt=""
  //         />
  //         <img src={IconNetworkCFrmStr} height="22px" width="22px" />
  //       </span>
  //     </FItem>
  //   ),
  //   id: "6238386bd292da2db05524f9",
  //   contract: "0xaf329a957653675613D0D98f49fc93326AeB36Fc",
  //   LpCurrency: "0xaf329a957653675613D0D98f49fc93326AeB36Fc",
  //   LPstakingAddress: "0x35E15ff9eBB37D8C7A413fD85BaD515396DC8008",
  //   network: "BSC",
  //   internalName: "cFRM",
  // },
  // {
  //   sustainableCrucibleFarms: "cFRMx / BNB",
  //   stepFlowName: "cFRMx / BNB Crucible Farm - Farming Dashboard Flow",
  //   totalStaked: getTotalStaked("cFRMx-BNB"),
  //   yourDeposit: getYourDeposited("cFRMx-BNB", "0x35E15ff9eBB37D8C7A413fD85BaD515396DC8008"),
  //   yourRewards: getYourRewards("cFRMx-BNB", "0x35E15ff9eBB37D8C7A413fD85BaD515396DC8008"),
  //   apr: Object.keys(aprInformation).length && getAPRValueAgainstFarm(aprInformation, 'cFRMx-BNB'),
  //   network: "BSC",
  //   logo: (
  //     <>
  //       <img src={IconNetworkCFrmxStr} height="22px" width="22px" />
  //       <img src={IconNetworkBNB} height="22px" width="22px" />{" "}
  //     </>
  //   ),
  //   id: "62383841d292da2db05524f3",
  //   contract: "0x1fC45F358D5292bEE1e055BA7CebE4d4100972AE",
  //   LpCurrency: "0xb76b11410A506495418D20c58F9452c17CF285c1",
  //   LPstakingAddress: "0x35E15ff9eBB37D8C7A413fD85BaD515396DC8008",
  //   internalName: "cFRMx-BNB",
  // },
  // {
  //   sustainableCrucibleFarms: "cFRMx",
  //   stepFlowName: "cFRMx Crucible Farm - Farming Dashboard Flow",
  //   totalStaked: getTotalStaked("cFRMx"),
  //   yourDeposit: getYourDeposited("cFRMx", "0x35E15ff9eBB37D8C7A413fD85BaD515396DC8008"),
  //   yourRewards: getYourRewards("cFRMx", "0x35E15ff9eBB37D8C7A413fD85BaD515396DC8008"),
  //   apr: Object.keys(aprInformation).length && getAPRValueAgainstFarm(aprInformation, 'cFRMx'),
  //   logo: (
  //     <FItem display={"flex"} alignY={"center"} className="w-100">
  //       <span className="card-apr-images icon-network f-pr--5 flex">
  //         <img src={networkLogoMap['BSC']} height="24px" width="24px" style={{ marginRight: "3px" }} alt="" />
  //         <img src={IconNetworkCFrmxStr} height="22px" width="22px" />{" "}
  //       </span>
  //     </FItem>
  //   ),
  //   id: "62383865d292da2db05524f6",
  //   contract: "0x1fC45F358D5292bEE1e055BA7CebE4d4100972AE",
  //   LpCurrency: "0x1fC45F358D5292bEE1e055BA7CebE4d4100972AE",
  //   LPstakingAddress: "0x35E15ff9eBB37D8C7A413fD85BaD515396DC8008",
  //   network: "BSC",
  //   internalName: "cFRMx",
  // }
  // ];

  const getStepToRender = async (
    id: any,
    stepFlowName: any,
    contract: string,
    network: string,
    LpCurrency?: string,
    LPstakingAddress?: string,
    farm?: any
  ) => {
    if (isConnected && tokenV2) {
      setIsLoading(true);
      // console.log("on manage click", currentStep, currentStepIndex, stepFlowStepHistory);
      getLatestStepToRender(
        { id, stepFlowName, contract, network, LpCurrency, LPstakingAddress },
        tokenV2,
        currentStep,
        currentStepIndex,
        stepFlowStepHistory,
        dispatch,
        history,
        farm,
        setIsLoading
      );
    } else {
      setShowConnectDialog(true);
    }
  };

  const GlobalStyles = createGlobalStyle`
  .f-container, .f-ml-0 {
    .crucible-dashboard {
      .f-card-body {
        .f-item {
          .f-input-group {
            .f-input-wrap {
              background: ${theme?.colors?.background} !important;
              border-color: ${theme?.colors?.neutralLight} !important;
              input::placeholder {
                color: ${theme?.colors?.backgroundLight} !important;
              }
            }
          }
        }
      }
      .f-table-wrapper {
        .f-table {
          .controlRow__root {
            .ButtonGroup__root{
              button:nth-child(2) {
                color: ${theme?.colors?.primaryLight} !important;
              }
              button:nth-child(3) {
                background: ${theme?.colors?.primary} !important;
              }
              button:nth-child(4) {
                color: ${theme?.colors?.primaryLight} !important;
              }
            }
          }
          table {
            width: 98%;
            margin-left: 10px;
            margin-right: 10px;
            .thead {
              .thead-tr {
                .thead-th {
                  color: ${theme?.colors?.backgroundLight} !important;
                }
              }
            }
            .tbody {
              .tbody-tr {
                .tbody-td:first-child:before, .tbody-td:first-child:after {
                  display: none;
                }
                outline: 1px solid ${theme?.colors?.backgroundLight} !important;
                border-radius: 12px;
                background: ${theme?.colors?.backgroundDark} !important;
                td {
                  .f-btn, .f-btn-primary, .text-decoration-none {
                    background: ${theme?.colors?.primary} !important;
                    border: 1px solid ${theme?.colors?.primary} !important;
                    color: ${theme?.colors?.backgroundDark} !important;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

  return (
    <ThemeProvider theme={theme}>
      <>
        {isLoading || isRedirecting ? (
          // <FCard variant={""} className={"new-bg-body"}>
          <FItem align={"center"}>
            <ClipLoader
              color={theme?.colors?.primary}
              loading={true}
              size={150}
            />
          </FItem>
        ) : (
          // </FCard>
          <FCard className="crucible-dashboard card-apr new-bg-body padding_0">
            <FItem
              display={"flex"}
              alignX="center"
              alignY={"center"}
              className="f-pb-1 f-m-0"
            >
              <FTypo
                className="card-title"
                color={theme?.colors?.primaryLight}
                size={20}
                weight={700}
              >
                {content?.dashboard?.header}
              </FTypo>
              <FInputText
                type={"text"}
                placeholder="Search by Farm Name, Token Name, Token Contract Address"
                disabled
              />
            </FItem>
            <FTable>
              <DatatableWrapper body={body} headers={tableHeads}>
                <Table>
                  <TableHeader />
                  <TableBody />
                </Table>
              </DatatableWrapper>
            </FTable>
          </FCard>
        )}

        <FDialog
          show={showConnectDialog}
          size={"medium"}
          onHide={() => setShowConnectDialog(false)}
          title={"Connect to Metamask"}
          className="connect-wallet-dialog "
        >
          <WalletConnector
            WalletConnectView={FButton}
            WalletConnectModal={ConnectWalletDialogMultiSwap}
            WalletConnectViewProps={{ className: "w-100" }}
          />
        </FDialog>
      </>
      <GlobalStyles />
    </ThemeProvider>
  );
};
